export const formationTypes = {
  DIPLOMA: 'Diplômante',
  CERTIFYING: 'Certifiante',
  ACCELERATED: 'Formation accélérée',
} satisfies Record<string, string>;

export type FormationType = keyof typeof formationTypes;
